import React from "react";
import { SlidePages } from "../../components/slidePages";
import { Interventions } from "../../components/serviceDetails/intervention";
import { ServiceCards } from "../../components/serviceDetails/serviceCards";
import { Realisation } from "../../components/home/realisation";
import { DemandeDevis } from "../../components/home/demandeDevis";
import { Prestations } from "../../components/home/prestations";
import inv1 from "../../assets/images/inv1.png";
import inv2 from "../../assets/images/inv2.png";
import inv3 from "../../assets/images/inv3.png";
import { GainIcon } from "../../assets/icons/GainIcon";
import { Valorisation } from "../../assets/icons/Valorisation";
import { OptimisationIcon } from "../../assets/icons/OptimisationIcon";
import rea1 from "../../assets/images/rea27.png";
import rea2 from "../../assets/images/rea28.png";
import rea3 from "../../assets/images/rea29.png";
import rea4 from "../../assets/images/rea30.png";
import rea5 from "../../assets/images/rea31.png";
import rea6 from "../../assets/images/rea32.png";
export const InvestisseursPage = () => {
  const prestations = [
    {
      icon: inv1,
      text: "Audit global",
    },
    {
      icon: inv2,
      text: "Travaux coordonnés : ITE, toiture, façade, électricité, plomberie",
    },
    {
      icon: inv3,
      text: "Livraison rapide, tout est prêt pour la location",
    },
  ];
  const items = [
    {
      icon: <GainIcon />,
      text: "Gain de temps",
    },
    {
      icon: <Valorisation />,
      text: "Valorisation du bien",
    },
    {
      icon: <OptimisationIcon />,
      text: "Optimisation fiscale",
    },
  ];
  const realisations = [
    {
      image: rea1,
      text: "Rénovation globale",
      link: "/renovation-investisseurs",
    },
    {
      image: rea2,
      text: "Rénovation globale",
      link: "/renovation-investisseurs",
    },
    {
      image: rea3,
      text: "Rénovation globale",
      link: "/renovation-investisseurs",
    },
    {
      image: rea4,
      text: "Rénovation globale",
      link: "/renovation-investisseurs",
    },
    {
      image: rea5,
      text: "Rénovation globale",
      link: "/renovation-investisseurs",
    },
    {
      image: rea6,
      text: "Rénovation globale",
      link: "/renovation-investisseurs",
    },
  ];
  return (
    <div>
      {" "}
      <SlidePages
        title={"Rénovation globale pour investisseurs"}
        description={
          "Vous avez un bien à rénover pour le revendre ou le louer ? Habitat IDF vous propose une solution clé en main : travaux + accompagnement administratif."
        }
      />
      <Interventions
        title={"Ce qu’on propose"}
        description={
          "Tout ce dont vous avez besoin pour une rénovation rentable et rapide."
        }
        prestations={prestations}
      />
      <ServiceCards
        items={items}
        title={"Bénéfices"}
        description={
          "Des avantages concrets pour rentabiliser rapidement votre investissement."
        }
      />
      <Realisation realisations={realisations} />
      <DemandeDevis title={"Parlez-nous de votre projet d’investissement !"} />
      <Prestations
        title={"D’autres services"}
        description={
          "Des solutions durables pour un habitat plus beau, plus sain et moins énergivore."
        }
      />
    </div>
  );
};
